<template>
  <div class="jd-loading-box">
    <div class="loading-img-box">
      <img class="loading-img" :src="$globalCdn + '/images/loading.gif'" alt />
    </div>
    <span class="loading-text">{{ text }}</span>
  </div>
</template>

<script>
export default {
  name: "jd-loading",
  props: {
    text: {
      type: String,
      default: "加载中...",
    },
  },
};
</script>

<style lang="scss" scoped>
.jd-loading-box {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  min-height: 500px;
  .loading-img-box {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 10px;
    .loading-img {
      width: 120px;
      height: 120px;
    }
  }
  .loading-text {
    font-size: 14px;
    width: 100%;
    text-align: center;
    color: #666;
  }
}
</style>
